import { AxiosPostUrl } from "../../functions/axiosfunctions";

export function sendUpdateClientData(data: Object, cb = function (reponse: any) {}) {
  // console.log(data)
  AxiosPostUrl(
    "/administration/client/update",
    data,
    (reponse) => {
      if (reponse) {
        cb(reponse);
      } else {
        cb({
          success: false,
          data: {},
          msg: "Erreur survenue !",
        });
      }
    },
    function (reponse) {
      cb({
        success: false,
        data: {},
        msg: "Erreur survenue !",
      });
    }
  );
}
